import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';

Vue.use(new VueSocketIO({
  debug: process.env.DEV,
  connection: process.env.API_HOST,
  options: {
    path: '/api/socket',
    autoConnect: false,
  },
}));
